import {
    ACT_CONTACTS_ADD_CONNECTIONS_API,
    ACT_CONTACTS_GET_FAVOURITES_LIST_API,
    ACT_CONTACTS_SET_FAVOURITES_LIST_API,
    ACT_CONTACTS_GET_ROLE_REVISION_API,
    ACT_CONTACTS_GET_BIRTHDAYS_API,
    ACT_CONTACTS_GET_CONTACT_API,
    ACT_CONTACTS_GET_CONTACTS_API,
    ACT_CONTACTS_GET_CONTACTS_STATUS_API,
    ACT_CONTACTS_ADD_CONTACT_API,
    ACT_CONTACTS_CHANGE_CONTACT_API,
    ACT_CONTACTS_DELETE_CONTACT_API,
    ACT_CONTACTS_SEARCH_CONTACTS_API,
    ACT_CONTACTS_GET_ORG_FILTER_API,
    ACT_CONTACTS_INVITE_GUEST_CONTACT_API,
} from '../../actionsTypes'


import module from '../../modules/contacts'
import proto from '../../../protocol'

const actions = {
    async [ACT_CONTACTS_ADD_CONNECTIONS_API](obj, payload) {
        return proto.addContactConnections(payload)
    },
    async [ACT_CONTACTS_GET_FAVOURITES_LIST_API]() {
        return proto.getFavouritesList()
    },
    async [ACT_CONTACTS_SET_FAVOURITES_LIST_API](obj, payload) {
        return proto.setFavouritesList(payload)
    },
    async [ACT_CONTACTS_GET_ROLE_REVISION_API]() {
        return proto.getRoleRevision()
    },
    async [ACT_CONTACTS_GET_BIRTHDAYS_API](obj, payload) {
        return proto.getBirthdays(payload)
    },
    async [ACT_CONTACTS_GET_CONTACT_API](obj, payload) {
        return proto.getContact(payload)
    },
    async [ACT_CONTACTS_GET_CONTACTS_API](obj, payload) {
        return proto.getContacts(payload)
    },
    async [ACT_CONTACTS_GET_CONTACTS_STATUS_API](obj, payload) {
        return proto.getContactsStatus(payload)
    },
    async [ACT_CONTACTS_ADD_CONTACT_API](obj, payload) {
        return proto.addContact(payload)
    },
    async [ACT_CONTACTS_CHANGE_CONTACT_API](obj, payload) {
        return proto.changeContact(payload)
    },
    async [ACT_CONTACTS_DELETE_CONTACT_API](obj, payload) {
        return proto.deleteContact(payload)
    },
    async [ACT_CONTACTS_SEARCH_CONTACTS_API](obj, payload) {
        return proto.searchContacts(payload)
    },
    async [ACT_CONTACTS_GET_ORG_FILTER_API]() {
        return proto.getContactsOrganizationFilter()
    },
    async [ACT_CONTACTS_INVITE_GUEST_CONTACT_API](obj, payload) {
        return proto.inviteGuestContact(payload)
    },
}

Object.assign(module.actions, actions)

export default module
